import { createSlice } from '@reduxjs/toolkit'

export const lookSlice = createSlice({
  name: 'look',
  initialState: {
    open: false,
    json: null,
    selectedId: 1,
    hoverId: null,
  },
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload
    },
    setJson: (state, action) => {
      state.json = action.payload
    },
    setSelectedId: (state, action) => {
      state.selectedId = action.payload
    },
    setHoverId: (state, action) => {
      state.hoverId = action.payload
    },
  },
})


export const { setOpen, setJson, setSelectedId, setHoverId } = lookSlice.actions

export default lookSlice.reducer
